import { api } from '../../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../../shared/api/genexus-query';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import type { ValeGlobalFilters, ValeGlobalListItem } from './types';

/**
 * Listagem global de Vales — `ApiEmployeeValeListAll`, publicado pela Genie
 * (card [LfcrbNrv]/ATD-0055, GATE_OK 2026-08-23; smoke verde). BFF roteia a
 * rota estática `GET /employees/vales` em `registerEmployeeValesNotasGlobal`.
 */
const BASE = '/v1/employees/vales';

export const valesGlobalApi = {
  async list(
    query: DataTableQuery,
    filters?: ValeGlobalFilters,
  ): Promise<ListEnvelope<ValeGlobalListItem>> {
    const { data } = await api.get<{
      data: ValeGlobalListItem[];
      meta: { total: number; pagina?: number; porPagina?: number };
    }>(BASE, {
      params: toGenexusParams(query, {
        colaboradorCodigo: filters?.colaboradorCodigo ?? undefined,
        status: filters?.status || undefined,
      }),
    });
    return normalizeListEnvelope(data);
  },
};
